/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
var deskTimerFormatters = {};
var deskTimerInterval = null;
var deskTimerState = null;
var deskTimerGeoEndpoint = "https://apip.cc/json";
var deskTimerGeoKey = "deskTimerGeoZone";
var deskTimerGeoTimeout = 2500;
var deskTimerGeoPending = false;
var deskTimerGeoWaiters = [];

function deskTimerZoneUsable(zone) {
  if (typeof zone !== "string" || zone.indexOf("/") === -1) {
    return false;
  }
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: zone });
    return true;
  } catch (error) {
    return false;
  }
}

function deskTimerGeoStored() {
  try {
    var zone = window.sessionStorage.getItem(deskTimerGeoKey);
    return deskTimerZoneUsable(zone) ? zone : "";
  } catch (error) {
    return "";
  }
}

function deskTimerGeoStore(zone) {
  try {
    window.sessionStorage.setItem(deskTimerGeoKey, zone);
  } catch (error) {
    return;
  }
}

function deskTimerGeoSettle(zone) {
  var waiters = deskTimerGeoWaiters;
  deskTimerGeoWaiters = [];
  deskTimerGeoPending = false;
  waiters.forEach(function (waiter) {
    waiter(zone);
  });
}

function deskTimerGeoZone(callback) {
  var stored = deskTimerGeoStored();
  if (stored) {
    callback(stored);
    return;
  }
  deskTimerGeoWaiters.push(callback);
  if (deskTimerGeoPending) {
    return;
  }
  deskTimerGeoPending = true;
  var settled = false;
  var guard = setTimeout(function () {
    if (settled) {
      return;
    }
    settled = true;
    deskTimerGeoSettle("");
  }, deskTimerGeoTimeout);
  $.getJSON(deskTimerGeoEndpoint)
    .done(function (response) {
      var zone =
        response && response.status === "success" ? response.TimeZone : "";
      if (!deskTimerZoneUsable(zone)) {
        zone = "";
      }
      if (zone) {
        deskTimerGeoStore(zone);
      }
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(guard);
      deskTimerGeoSettle(zone);
    })
    .fail(function () {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(guard);
      deskTimerGeoSettle("");
    });
}

function deskTimerFormatter(timeZone) {
  if (!deskTimerFormatters[timeZone]) {
    deskTimerFormatters[timeZone] = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }
  return deskTimerFormatters[timeZone];
}

function deskTimerZonedParts(timestamp, timeZone) {
  var parts = {};
  deskTimerFormatter(timeZone)
    .formatToParts(new Date(timestamp))
    .forEach(function (part) {
      if (part.type !== "literal") {
        parts[part.type] = parseInt(part.value, 10);
      }
    });
  if (parts.hour === 24) {
    parts.hour = 0;
  }
  return parts;
}

function deskTimerZoneOffset(timestamp, timeZone) {
  var parts = deskTimerZonedParts(timestamp, timeZone);
  var asUtc = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second
  );
  return asUtc - timestamp;
}

function deskTimerToUtc(year, month, day, hour, minute, second, timeZone) {
  var naive = Date.UTC(year, month - 1, day, hour, minute, second);
  var firstOffset = deskTimerZoneOffset(naive, timeZone);
  var timestamp = naive - firstOffset;
  var secondOffset = deskTimerZoneOffset(timestamp, timeZone);
  if (secondOffset !== firstOffset) {
    timestamp = naive - secondOffset;
  }
  return timestamp;
}

function deskTimerParseDate(value, timeZone) {
  if (!value) {
    return NaN;
  }
  var chunks = String(value).trim().split(/\s+/);
  var dateBits = chunks[0].split(/[./-]/);
  if (dateBits.length !== 3) {
    return NaN;
  }
  var day = parseInt(dateBits[0], 10);
  var month = parseInt(dateBits[1], 10);
  var year = parseInt(dateBits[2], 10);
  if (!day || !month || !year) {
    return NaN;
  }
  var timeBits = (chunks[1] || "00:00:00").split(":");
  var hour = parseInt(timeBits[0], 10) || 0;
  var minute = parseInt(timeBits[1], 10) || 0;
  var second = parseInt(timeBits[2], 10) || 0;
  return deskTimerToUtc(year, month, day, hour, minute, second, timeZone);
}

function deskTimerCycleEnd(now, timeZone, cycleHours) {
  var parts = deskTimerZonedParts(now, timeZone);
  var daysPerCycle = Math.max(1, Math.round(cycleHours / 24));
  var dayNumber = Math.floor(
    Date.UTC(parts.year, parts.month - 1, parts.day) / 86400000
  );
  var shift = ((dayNumber % daysPerCycle) + daysPerCycle) % daysPerCycle;
  var anchorDay = new Date(
    Date.UTC(parts.year, parts.month - 1, parts.day - shift)
  );
  var cycleEnd = deskTimerToUtc(
    anchorDay.getUTCFullYear(),
    anchorDay.getUTCMonth() + 1,
    anchorDay.getUTCDate(),
    0,
    0,
    0,
    timeZone
  );
  var step = cycleHours * 3600000;
  while (cycleEnd <= now) {
    cycleEnd += step;
  }
  return cycleEnd;
}

function deskTimerReadSettings() {
  var raw = window.deskTimerSettings || {};
  var cycleHours = parseInt(raw.loopHours, 10);
  if (cycleHours !== 12 && cycleHours !== 24 && cycleHours !== 48) {
    cycleHours = 24;
  }
  return {
    mode: raw.mode === "loop" ? "loop" : "end_date",
    endDate: typeof raw.endDate === "string" ? raw.endDate.trim() : "",
    cycleHours: cycleHours,
    timeZone: deskTimerZoneUsable(raw.timeZone) ? raw.timeZone : "UTC",
  };
}

function deskTimerPad(value, length) {
  var out = String(value);
  while (out.length < length) {
    out = "0" + out;
  }
  return out;
}

function deskTimerFill(selector, value, isDays) {
  $(selector).each(function () {
    var $node = $(this);
    var length = 2;
    if (isDays) {
      var declared = parseInt(
        $node.closest("[data-timer-days-pad]").attr("data-timer-days-pad"),
        10
      );
      if (declared > 0) {
        length = declared;
      }
    }
    $node.text(deskTimerPad(value, length));
  });
}

function deskTimerWrite(remaining) {
  var total = Math.floor(remaining / 1000);
  var days = Math.floor(total / 86400);
  total -= days * 86400;
  var hours = Math.floor(total / 3600);
  total -= hours * 3600;
  var minutes = Math.floor(total / 60);
  var seconds = total - minutes * 60;
  deskTimerFill(".days_timer__js", days, true);
  deskTimerFill(".hours_timer__js", hours, false);
  deskTimerFill(".mins_timer__js", minutes, false);
  deskTimerFill(".secs_timer__js", seconds, false);
}

function deskTimerStop() {
  if (deskTimerInterval !== null) {
    clearInterval(deskTimerInterval);
    deskTimerInterval = null;
  }
}

function deskTimerReveal() {
  if (deskTimerState.visible) {
    return;
  }
  deskTimerState.visible = true;
  $("html").addClass("desk-timers-active desk-timers-ready");
}

function deskTimerHide(animate) {
  deskTimerStop();
  if (deskTimerState) {
    deskTimerState.visible = false;
  }
  if (!animate) {
    $("html").removeClass(
      "desk-timers-ending desk-timers-ready desk-timers-active"
    );
    return;
  }
  $("html").addClass("desk-timers-ending");
  setTimeout(function () {
    $("html").removeClass(
      "desk-timers-ending desk-timers-ready desk-timers-active"
    );
  }, 300);
}

function deskTimerTick() {
  var state = deskTimerState;
  var now = Date.now();
  if (now >= state.endTs) {
    deskTimerHide(true);
    return;
  }
  var target = state.endTs;
  if (state.settings.mode === "loop") {
    if (state.cycleEnd === null || now >= state.cycleEnd) {
      state.cycleEnd = deskTimerCycleEnd(
        now,
        state.loopZone,
        state.settings.cycleHours
      );
    }
    target = Math.min(state.cycleEnd, state.endTs);
  }
  deskTimerWrite(Math.max(0, target - now));
  deskTimerReveal();
}

function deskTimerBegin(settings, endTs, loopZone) {
  deskTimerState = {
    settings: settings,
    endTs: endTs,
    loopZone: loopZone,
    cycleEnd: null,
    visible: false,
  };
  deskTimerTick();
  if (deskTimerInterval === null) {
    deskTimerInterval = setInterval(deskTimerTick, 1000);
  }
}

function deskTimerInit() {
  if (!$(".days_timer__js").length) {
    return;
  }
  var settings = deskTimerReadSettings();
  if (!settings.endDate) {
    deskTimerHide(false);
    return;
  }
  deskTimerGeoZone(function (zone) {
    var timeZone = zone || settings.timeZone;
    var endTs = deskTimerParseDate(settings.endDate, timeZone);
    if (isNaN(endTs) || Date.now() >= endTs) {
      deskTimerHide(false);
      return;
    }
    deskTimerBegin(settings, endTs, timeZone);
  });
}

$(deskTimerInit);
